// Pet Portrait Product JavaScript

// Global state
let selectedVariantId = null;
let selectedBgColor = { name: 'Baby Blue', hex: '#bfdbfe' };
let uploadcareWidget = null;
let uploadedFileInfo = null;

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initializePetPortrait();
  initializeUploadcare();
  initializeUrgencyCounter();
  initializePetNamePreview();
  initializeCountdownTimer();
  initializeDesignSlots();
  initializeCharacterCounter();
  initializeCarousel();
  initializeMainGallerySwipe();
  initializeAutoSlideshow();
});

function initializePetPortrait() {
  // Set initial variant to A4 (or first if A4 not found)
  const a4SizeOption = document.querySelector('.pet-size-option.active');
  if (a4SizeOption) {
    selectedVariantId = a4SizeOption.dataset.variantId;

    // Update the variant select dropdown
    const variantSelect = document.getElementById('petVariantSelect');
    if (variantSelect) {
      variantSelect.value = selectedVariantId;
    }

    // Initialize the price display with A4 price
    updateTotalPrice();
  }
}

function initializeUploadcare() {
  // Initialize Uploadcare widget
  const uploadInput = document.getElementById('petPhotoUpload');
  if (uploadInput && typeof uploadcare !== 'undefined') {
    uploadcareWidget = uploadcare.Widget(uploadInput);

    // Check if there's a preview URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const previewUrl = urlParams.get('preview');

    if (previewUrl) {
      // Automatically load the preview image
      uploadcareWidget.value(previewUrl);

      // Create a fake info object for the preview
      uploadedFileInfo = {
        cdnUrl: previewUrl,
        name: 'Custom Portrait Preview',
        uuid: 'preview-image'
      };

      // Show the preview immediately
      const previewDiv = document.getElementById('uploadPreview');
      const previewImg = document.getElementById('previewImage');
      const fileName = document.getElementById('fileName');

      if (previewDiv && previewImg && fileName) {
        previewImg.src = previewUrl;
        fileName.textContent = 'Custom Portrait Preview';
        previewDiv.style.display = 'block';
      }

      // Don't show email popup for preview images
      console.log('Preview image loaded:', previewUrl);
    }

    // Handle file selection
    uploadcareWidget.onUploadComplete(function(info) {
      console.log('Upload complete:', info);
      uploadedFileInfo = info; // Store file info globally

      const previewDiv = document.getElementById('uploadPreview');
      const previewImg = document.getElementById('previewImage');
      const fileName = document.getElementById('fileName');

      if (previewDiv && previewImg && fileName && info.cdnUrl) {
        previewImg.src = info.cdnUrl;
        fileName.textContent = info.name || 'Uploaded photo';
        previewDiv.style.display = 'block';
      }

      // Only show email popup for new uploads (not preview images)
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.get('preview')) {
        setTimeout(() => {
          showEmailPopup();
        }, 500);
      }
    });

    uploadcareWidget.onChange(function(file) {
      if (file) {
        file.done(function(info) {
          console.log('File uploaded:', info);
        });
      }
    });
  }
}

// Email Popup Functions
function showEmailPopup() {
  const modal = document.getElementById('emailPopupModal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeEmailPopup() {
  const modal = document.getElementById('emailPopupModal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = 'auto';
  }
}

function submitEmailCapture(event) {
  event.preventDefault();

  const email = document.getElementById('previewEmail').value;

  if (!uploadedFileInfo) {
    console.error('No file uploaded');
    return;
  }

  const data = {
    email: email,
    fileName: uploadedFileInfo.name,
    fileUrl: uploadedFileInfo.cdnUrl,
    fileUuid: uploadedFileInfo.uuid,
    timestamp: new Date().toISOString()
  };

  // Send to your storage endpoint (see options below)
  sendToStorage(data);

  // Show success message
  const modalContent = document.querySelector('.pet-email-modal-content');
  if (modalContent) {
    modalContent.innerHTML = `
      <div style="text-align: center; padding: 2rem;">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" style="margin: 0 auto 1rem;">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        <h3 style="font-size: 2rem; margin-bottom: 1rem; color: #22c55e;">Perfect! ✓</h3>
        <p style="font-size: 1.5rem; color: #6b7280; margin-bottom: 2rem;">We'll send your free preview to<br><strong>${email}</strong></p>
        <button onclick="closeEmailPopup()" style="background: #ec4899; color: white; border: none; padding: 1rem 2rem; border-radius: 0.75rem; font-size: 1.5rem; cursor: pointer; font-weight: 600;">Continue Customizing</button>
      </div>
    `;
  }

  setTimeout(() => {
    closeEmailPopup();
  }, 3000);
}

function sendToStorage(data) {
  console.log('Sending data to Google Sheets:', data);

  // Send to Google Sheets via Apps Script
  fetch('https://script.google.com/macros/s/AKfycbweuidqnjPvTcljrvuo1VNE4adRAHkemU4sb2fPAr0tG0zLflBTo-HxFVP-dB8Rmffu/exec', {
    method: 'POST',
    mode: 'no-cors', // Required for Google Apps Script
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
  .then(() => {
    console.log('Data sent successfully to Google Sheets');
  })
  .catch(error => {
    console.error('Error sending data:', error);
  });
}

// Image Modal Functions
function openPetModal(imageSrc) {
  const modal = document.getElementById('imageModal');
  const modalImage = document.getElementById('modalImage');
  if (modal && modalImage) {
    modalImage.src = imageSrc;
    modal.style.display = 'flex';
  }
}

function closePetModal() {
  const modal = document.getElementById('imageModal');
  if (modal) {
    modal.style.display = 'none';
  }
}

// Close modal on escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closePetModal();
  }
});

// Image Gallery Functions
function changePetImage(imageSrc, dotElement) {
  const mainImage = document.getElementById('petMainImage');
  if (mainImage) {
    mainImage.src = imageSrc;
  }

  // Update active dot
  const dots = document.querySelectorAll('.pet-dot');
  dots.forEach(dot => dot.classList.remove('active'));
  if (dotElement) {
    dotElement.classList.add('active');
  }
}

// Custom Color Picker Functions
function openCustomColorPicker() {
  const modal = document.getElementById('colorPickerModal');
  if (modal) {
    modal.style.display = 'flex';
  }
}

function closeCustomColorPicker() {
  const modal = document.getElementById('colorPickerModal');
  if (modal) {
    modal.style.display = 'none';
  }
}

function applyCustomColor() {
  const colorPicker = document.getElementById('customColorPicker');
  const customColorBtn = document.querySelector('.pet-custom-color');

  if (colorPicker && customColorBtn) {
    const hexColor = colorPicker.value;

    // Update the custom button's color display
    const customColorDiv = customColorBtn.querySelector('.pet-bg-color');
    if (customColorDiv) {
      customColorDiv.style.background = hexColor;
      customColorDiv.innerHTML = ''; // Remove the icon
    }

    // Select the custom color
    selectPetBg(customColorBtn, hexColor, 'Custom');

    // Close the modal
    closeCustomColorPicker();
  }
}

// Update color preview in picker
document.addEventListener('DOMContentLoaded', function() {
  const colorPicker = document.getElementById('customColorPicker');
  const colorPreviewBox = document.getElementById('colorPreviewBox');
  const colorHexValue = document.getElementById('colorHexValue');

  if (colorPicker && colorPreviewBox && colorHexValue) {
    colorPicker.addEventListener('input', function(e) {
      const color = e.target.value;
      colorPreviewBox.style.backgroundColor = color;
      colorHexValue.textContent = color.toUpperCase();
    });
  }
});

// Size Selection
function selectPetSize(button, variantId) {
  // Remove active class from all size options
  const sizeOptions = document.querySelectorAll('.pet-size-option');
  sizeOptions.forEach(option => option.classList.remove('active'));

  // Add active class to selected option
  button.classList.add('active');

  // Update selected variant
  selectedVariantId = variantId;

  // Update variant select
  const variantSelect = document.getElementById('petVariantSelect');
  if (variantSelect) {
    variantSelect.value = variantId;
  }

  // Update price in add to cart button AND top price
  const price = button.dataset.price;
  const currentPriceElement = document.getElementById('currentPrice');
  const topPriceElement = document.getElementById('topPrice');

  if (currentPriceElement && price) {
    currentPriceElement.textContent = price;
  }

  if (topPriceElement && price) {
    topPriceElement.textContent = price;
  }

  // Update compare at price and save badge
  const compareAtPrice = button.dataset.compareAtPrice;
  const compareAtPriceRaw = parseInt(button.dataset.compareAtPriceRaw);
  const priceRaw = parseInt(button.dataset.priceRaw);
  const compareAtPriceElement = document.querySelector('.pet-compare-price');
  const saveBadgeElement = document.getElementById('saveBadge');

  // Show or hide compare at price based on whether it exists
  if (compareAtPriceRaw && compareAtPriceRaw > priceRaw) {
    // Show compare at price
    if (compareAtPriceElement) {
      compareAtPriceElement.textContent = compareAtPrice;
      compareAtPriceElement.style.display = '';
    }

    // Update save badge
    if (saveBadgeElement) {
      const savings = Math.floor((compareAtPriceRaw - priceRaw) / 100);
      saveBadgeElement.textContent = `Save £${savings}`;
      saveBadgeElement.style.display = '';
    }
  } else {
    // Hide compare at price and save badge if no discount
    if (compareAtPriceElement) {
      compareAtPriceElement.style.display = 'none';
    }
    if (saveBadgeElement) {
      saveBadgeElement.style.display = 'none';
    }
  }

  // Update variant based on all selections
  updateVariant();

  // Update upsell total price
  updateTotalPrice();
}

// Background Color Selection
function selectPetBg(button, hexColor, colorName) {
  // Remove active class from all bg options
  const bgOptions = document.querySelectorAll('.pet-bg-option');
  bgOptions.forEach(option => option.classList.remove('active'));

  // Add active class to selected option
  button.classList.add('active');

  // Get color info from button if not provided
  if (!hexColor) {
    hexColor = button.dataset.hex;
  }
  if (!colorName) {
    colorName = button.dataset.color;
  }

  // Update global state
  selectedBgColor = { name: colorName, hex: hexColor };

  // Update hidden input for form submission
  const hiddenInput = document.getElementById('selectedBgColor');
  if (hiddenInput) {
    hiddenInput.value = `${colorName} (${hexColor})`;
  }

  console.log('Selected background color:', selectedBgColor);
}

// Font Selection
function selectPetFont(button) {
  // Remove active class from all font options
  const fontOptions = document.querySelectorAll('.pet-font-option');
  fontOptions.forEach(option => option.classList.remove('active'));

  // Add active class to selected option
  button.classList.add('active');

  // Get the selected font
  const selectedFont = button.dataset.font;

  // Update the live preview font
  const previewText = document.getElementById('petNamePreview');
  if (previewText && selectedFont) {
    // Apply the selected font to the preview
    if (selectedFont === 'No text' || selectedFont === 'None') {
      // Hide preview for no text option
      const previewContainer = document.getElementById('petNamePreviewContainer');
      if (previewContainer) {
        previewContainer.style.display = 'none';
      }
    } else {
      // Apply the font family with correct fallback
      let fontFamily;
      if (selectedFont === 'Caveat') {
        fontFamily = "'Caveat', cursive";
      } else if (selectedFont === 'Montserrat') {
        fontFamily = "'Montserrat', sans-serif";
      } else if (selectedFont === 'Quicksand') {
        fontFamily = "'Quicksand', sans-serif";
      } else {
        fontFamily = `'${selectedFont}', sans-serif`;
      }
      previewText.style.fontFamily = fontFamily;
    }
  }

  // Update variant based on all selections
  updateVariant();
}

// Update variant based on selected size only
// Background color and font are now properties, not variants
function updateVariant() {
  const selectedSize = document.querySelector('.pet-size-option.active');
  const selectedFont = document.querySelector('.pet-font-option.active');

  if (!selectedSize) return;

  // Build variant title based on size and font
  let variantTitle = selectedSize.querySelector('.pet-size-name').textContent;

  if (selectedFont) {
    const font = selectedFont.dataset.font;
    if (font) {
      variantTitle += ' / ' + font;
    }
  }

  // Find matching variant (only by size and font, not background color)
  const variantSelect = document.getElementById('petVariantSelect');
  if (variantSelect) {
    const options = variantSelect.querySelectorAll('option');
    let matchingVariant = null;

    // Try to find exact match
    for (let option of options) {
      const optionText = option.textContent;
      const sizeName = selectedSize.querySelector('.pet-size-name').textContent;

      if (optionText.includes(sizeName)) {
        matchingVariant = option;

        // If we have font selection, try to find better match
        if (selectedFont) {
          const font = selectedFont.dataset.font;
          if (optionText.includes(font)) {
            matchingVariant = option;
            break;
          }
        } else if (!optionText.includes('/') || optionText.split('/').length <= 2) {
          // Prefer variants without extra options if no font selected
          break;
        }
      }
    }

    if (matchingVariant) {
      variantSelect.value = matchingVariant.value;
      selectedVariantId = matchingVariant.value;

      // Update price in add to cart button AND top price
      const price = selectedSize.dataset.price;
      const currentPriceElement = document.getElementById('currentPrice');
      const topPriceElement = document.getElementById('topPrice');

      if (currentPriceElement && price) {
        currentPriceElement.textContent = price;
      }

      if (topPriceElement && price) {
        topPriceElement.textContent = price;
      }

      // Update compare at price and save badge
      const compareAtPrice = selectedSize.dataset.compareAtPrice;
      const compareAtPriceRaw = parseInt(selectedSize.dataset.compareAtPriceRaw);
      const priceRaw = parseInt(selectedSize.dataset.priceRaw);
      const compareAtPriceElement = document.querySelector('.pet-compare-price');
      const saveBadgeElement = document.getElementById('saveBadge');

      // Show or hide compare at price based on whether it exists
      if (compareAtPriceRaw && compareAtPriceRaw > priceRaw) {
        // Show compare at price
        if (compareAtPriceElement) {
          compareAtPriceElement.textContent = compareAtPrice;
          compareAtPriceElement.style.display = '';
        }

        // Update save badge
        if (saveBadgeElement) {
          const savings = Math.floor((compareAtPriceRaw - priceRaw) / 100);
          saveBadgeElement.textContent = `Save £${savings}`;
          saveBadgeElement.style.display = '';
        }
      } else {
        // Hide compare at price and save badge if no discount
        if (compareAtPriceElement) {
          compareAtPriceElement.style.display = 'none';
        }
        if (saveBadgeElement) {
          saveBadgeElement.style.display = 'none';
        }
      }
    }
  }
}

// Form submission handler
const petForm = document.getElementById('pet-portrait-form');
if (petForm) {
  petForm.addEventListener('submit', async function(e) {
    e.preventDefault(); // Prevent default form submission

    // Validate file upload
    const fileInput = document.querySelector('input[name="properties[Pet Photo]"]');
    if (!fileInput || !fileInput.value) {
      alert('Please upload a photo of your pet before adding to cart.');
      return false;
    }

    // Get pet name
    const petNameInput = document.getElementById('petNameInput');
    const petName = petNameInput ? petNameInput.value : '';

    // Add the pet name to cart properties
    if (petName) {
      let nameInput = petForm.querySelector('input[name="properties[Pet Name]"]');
      if (!nameInput) {
        nameInput = document.createElement('input');
        nameInput.type = 'hidden';
        nameInput.name = 'properties[Pet Name]';
        petForm.appendChild(nameInput);
      }
      nameInput.value = petName;
    }

    // Show loading state
    const submitButton = petForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.innerHTML : '';
    if (submitButton) {
      submitButton.innerHTML = '<span>Adding to cart...</span>';
      submitButton.disabled = true;
      submitButton.style.opacity = '0.7';
    }

    try {
      // Get form data
      const formData = new FormData(petForm);

      // Get variant ID
      const variantId = formData.get('id');

      // Build properties object from form data
      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          const propName = key.slice(11, -1); // Extract property name
          properties[propName] = value;
        }
      }

      // Add to cart using AJAX
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Redirect to checkout
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('There was an error adding to cart. Please try again.');

      // Restore button
      if (submitButton) {
        submitButton.innerHTML = originalButtonText;
        submitButton.disabled = false;
        submitButton.style.opacity = '1';
      }
    }
  });
}

// Urgency Counter - Simulates viewer count
function initializeUrgencyCounter() {
  const urgencyText = document.getElementById('urgencyText');
  if (!urgencyText) return;

  // Generate a random viewer count between 8-18
  function getRandomViewers() {
    return Math.floor(Math.random() * 11) + 8; // Random between 8-18
  }

  // Update viewer count
  function updateViewerCount() {
    const count = getRandomViewers();
    urgencyText.textContent = `${count} people are viewing this right now`;
  }

  // Initial update
  updateViewerCount();

  // Update every 15-25 seconds with slight variation
  setInterval(() => {
    updateViewerCount();
  }, (Math.random() * 10000) + 15000); // Random interval between 15-25 seconds
}

// Update font button previews - no longer needed as we show font names
function updateFontButtonPreviews() {
  // Font buttons now show the font name itself, not dynamic pet name
  // This function is kept for compatibility but does nothing
  return;
}

// Pet Name Live Preview
function initializePetNamePreview() {
  const petNameInput = document.getElementById('petNameInput');
  const previewContainer = document.getElementById('petNamePreviewContainer');
  const previewText = document.getElementById('petNamePreview');

  if (!petNameInput || !previewContainer || !previewText) return;

  // Initialize font button previews
  updateFontButtonPreviews();

  // Handle input changes in real-time
  petNameInput.addEventListener('input', function(e) {
    const value = e.target.value.trim();

    // Update font button previews
    updateFontButtonPreviews();

    // Check if "No text" font is selected
    const selectedFontButton = document.querySelector('.pet-font-option.active');
    const selectedFont = selectedFontButton ? selectedFontButton.dataset.font : null;

    if (value.length > 0) {
      // Don't show preview if "No text" is selected
      if (selectedFont === 'No text' || selectedFont === 'None') {
        previewContainer.style.display = 'none';
        return;
      }

      // Show the preview container with animation
      previewContainer.style.display = 'block';

      // Update the preview text
      previewText.textContent = value;

      // Apply the selected font with correct fallback
      if (selectedFont) {
        let fontFamily;
        if (selectedFont === 'Caveat') {
          fontFamily = "'Caveat', cursive";
        } else if (selectedFont === 'Montserrat') {
          fontFamily = "'Montserrat', sans-serif";
        } else if (selectedFont === 'Quicksand') {
          fontFamily = "'Quicksand', sans-serif";
        } else {
          fontFamily = `'${selectedFont}', sans-serif`;
        }
        previewText.style.fontFamily = fontFamily;
      }

      // Trigger animation by removing and re-adding the animation class
      previewText.style.animation = 'none';
      setTimeout(() => {
        previewText.style.animation = '';
      }, 10);
    } else {
      // Hide the preview if input is empty
      previewContainer.style.display = 'none';
    }
  });

  // Also handle keyup for better responsiveness
  petNameInput.addEventListener('keyup', function(e) {
    const value = e.target.value.trim();

    if (value.length > 0 && previewContainer.style.display === 'none') {
      // Check if "No text" font is selected
      const selectedFontButton = document.querySelector('.pet-font-option.active');
      const selectedFont = selectedFontButton ? selectedFontButton.dataset.font : null;

      // Only show if not "No text"
      if (selectedFont !== 'No text' && selectedFont !== 'None') {
        previewContainer.style.display = 'block';
      }
    }
  });
}

// Calculate delivery date (6 business days from today)
function calculateDeliveryDate() {
  const today = new Date();
  let businessDaysToAdd = 6;
  let currentDate = new Date(today);

  while (businessDaysToAdd > 0) {
    currentDate.setDate(currentDate.getDate() + 1);
    // Check if it's a weekday (Monday = 1, Friday = 5)
    const dayOfWeek = currentDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Not Saturday (6) or Sunday (0)
      businessDaysToAdd--;
    }
  }

  return currentDate;
}

// Format delivery date nicely
function formatDeliveryDate(date) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];

  // Add ordinal suffix (1st, 2nd, 3rd, 4th, etc.)
  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  return `${dayName}, ${month} ${day}${suffix(day)}`;
}

// Delivery Countdown Timer - Shows actual delivery date
function initializeCountdownTimer() {
  const deliveryTimeElement = document.getElementById('deliveryTimeRemaining');
  const deliveryDateElement = document.getElementById('deliveryDate');

  if (!deliveryTimeElement) return;

  function updateDeliveryCountdown() {
    const now = new Date();
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);

    const diff = endOfDay - now;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    deliveryTimeElement.textContent = `${hours}h ${minutes}m`;

    // Update delivery date
    if (deliveryDateElement) {
      const deliveryDate = calculateDeliveryDate();
      deliveryDateElement.textContent = formatDeliveryDate(deliveryDate);
    }

    // Check if it's midnight and reset
    if (hours === 0 && minutes === 0) {
      setTimeout(updateDeliveryCountdown, 1000);
    }
  }

  updateDeliveryCountdown();
  setInterval(updateDeliveryCountdown, 60000); // Update every minute
}

// Design Slots Counter
function initializeDesignSlots() {
  const slotsElement = document.getElementById('slotsRemaining');
  if (!slotsElement) return;

  // Simulate decreasing slots (2-4 remaining)
  const slots = Math.floor(Math.random() * 3) + 2;
  slotsElement.textContent = slots;

  // Occasionally decrease by 1
  setInterval(() => {
    const currentSlots = parseInt(slotsElement.textContent);
    if (currentSlots > 1 && Math.random() > 0.7) {
      slotsElement.textContent = currentSlots - 1;
    }
  }, 120000); // Check every 2 minutes
}

// Character Counter
function initializeCharacterCounter() {
  const petNameInput = document.getElementById('petNameInput');
  const charCount = document.getElementById('charCount');

  if (!petNameInput || !charCount) return;

  petNameInput.addEventListener('input', function() {
    charCount.textContent = this.value.length;
  });
}

// Carousel Navigation
let currentSlide = 0;

function initializeCarousel() {
  const carousel = document.getElementById('beforeAfterCarousel');
  if (!carousel) return;

  // Enable touch swipe on mobile
  let touchStartX = 0;
  let touchEndX = 0;

  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  carousel.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    if (touchEndX < touchStartX - 50) {
      changeCarouselSlide(1); // Swipe left
    }
    if (touchEndX > touchStartX + 50) {
      changeCarouselSlide(-1); // Swipe right
    }
  }
}

function changeCarouselSlide(direction) {
  const items = document.querySelectorAll('.pet-before-after-item');
  const dots = document.querySelectorAll('.pet-carousel-dot');

  if (items.length === 0) return;

  // Remove active class from current slide
  items[currentSlide].classList.remove('active');
  dots[currentSlide].classList.remove('active');

  // Calculate new slide
  currentSlide = (currentSlide + direction + items.length) % items.length;

  // Add active class to new slide
  items[currentSlide].classList.add('active');
  dots[currentSlide].classList.add('active');
}

function goToSlide(index) {
  const items = document.querySelectorAll('.pet-before-after-item');
  const dots = document.querySelectorAll('.pet-carousel-dot');

  if (items.length === 0) return;

  // Remove active class from current slide
  items[currentSlide].classList.remove('active');
  dots[currentSlide].classList.remove('active');

  // Set new slide
  currentSlide = index;

  // Add active class to new slide
  items[currentSlide].classList.add('active');
  dots[currentSlide].classList.add('active');
}

// Upsell State
let digitalFileSelected = false;
let frameSelected = false;
let frameColor = '';
let basePrice = 0;

// Digital File Toggle
function toggleDigitalFile(checkbox) {
  digitalFileSelected = checkbox.checked;
  const digitalFileProperty = document.getElementById('digitalFileProperty');

  if (digitalFileProperty) {
    digitalFileProperty.value = digitalFileSelected ? 'Yes (+£5.00)' : '';
  }

  updateTotalPrice();
}

// Frame Toggle
function toggleFrame(checkbox) {
  frameSelected = checkbox.checked;
  const frameOptions = document.getElementById('frameOptions');
  const frameColorSelect = document.getElementById('frameColorSelect');

  if (frameOptions) {
    frameOptions.style.display = frameSelected ? 'block' : 'none';
  }

  if (!frameSelected) {
    frameColor = '';
    if (frameColorSelect) {
      frameColorSelect.value = '';
    }
  }

  updateFrameSelection();
}

// Update Frame Selection
function updateFrameSelection() {
  const frameCheckbox = document.getElementById('frameCheckbox');
  const frameColorSelect = document.getElementById('frameColorSelect');
  const frameProperty = document.getElementById('frameProperty');

  if (!frameCheckbox || !frameCheckbox.checked) {
    if (frameProperty) {
      frameProperty.value = '';
    }
    updateTotalPrice();
    return;
  }

  if (frameColorSelect) {
    frameColor = frameColorSelect.value;
  }

  // Update hidden property
  if (frameProperty && frameColor) {
    const framePrice = getFramePrice();
    frameProperty.value = `${frameColor} Frame (+£${framePrice.toFixed(2)})`;
  } else if (frameProperty) {
    frameProperty.value = '';
  }

  updateTotalPrice();
}

// Get Frame Price based on selected size
function getFramePrice() {
  const selectedSizeButton = document.querySelector('.pet-size-option.active');
  if (!selectedSizeButton) return 0;

  const sizeName = selectedSizeButton.querySelector('.pet-size-name');
  if (!sizeName) return 0;

  const size = sizeName.textContent.trim();

  // Frame pricing based on size
  const framePricing = {
    'A5': 15,
    'A4': 20,
    'A3': 25
  };

  return framePricing[size] || 0;
}

// Update Total Price with Upsells
function updateTotalPrice() {
  const selectedSizeButton = document.querySelector('.pet-size-option.active');
  if (!selectedSizeButton) return;

  // Get base price from the selected variant
  const priceRaw = parseInt(selectedSizeButton.dataset.priceRaw) || 0;
  basePrice = priceRaw / 100; // Convert from cents to pounds

  let totalPrice = basePrice;

  // Add digital file price
  if (digitalFileSelected) {
    totalPrice += 5;
  }

  // Add frame price
  const frameCheckbox = document.getElementById('frameCheckbox');
  const frameColorSelect = document.getElementById('frameColorSelect');

  if (frameCheckbox && frameCheckbox.checked && frameColorSelect && frameColorSelect.value) {
    totalPrice += getFramePrice();
  }

  // Update price displays
  const currentPriceElement = document.getElementById('currentPrice');
  const topPriceElement = document.getElementById('topPrice');

  if (currentPriceElement) {
    currentPriceElement.textContent = `£${totalPrice.toFixed(2)}`;
  }

  if (topPriceElement) {
    topPriceElement.textContent = `£${totalPrice.toFixed(2)}`;
  }
}

// Photo Guide Toggle
function togglePhotoGuide() {
  const photoGuide = document.getElementById('photoGuide');
  if (!photoGuide) return;

  if (photoGuide.style.display === 'none') {
    photoGuide.style.display = 'block';
  } else {
    photoGuide.style.display = 'none';
  }
}

// Main Gallery Swipe Functionality
function initializeMainGallerySwipe() {
  const mainImage = document.getElementById('petMainImage');
  const dots = document.querySelectorAll('.pet-dot');

  if (!mainImage || dots.length === 0) return;

  let touchStartX = 0;
  let touchEndX = 0;
  let currentImageIndex = 0;
  let isDragging = false;

  // Get all product images
  const productMedia = [];
  dots.forEach((dot, index) => {
    const imageUrl = dot.getAttribute('onclick').match(/'([^']+)'/)[1];
    productMedia.push(imageUrl);
  });

  // Wrap image in a container for slide animation
  const imageContainer = mainImage.parentElement;
  imageContainer.style.overflow = 'hidden';
  imageContainer.style.position = 'relative';

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchEndX - touchStartX;

    if (Math.abs(diff) > swipeThreshold) {
      let direction;
      if (diff > 0) {
        // Swipe right - previous image
        direction = 'right';
        currentImageIndex = (currentImageIndex - 1 + productMedia.length) % productMedia.length;
      } else {
        // Swipe left - next image
        direction = 'left';
        currentImageIndex = (currentImageIndex + 1) % productMedia.length;
      }

      // Add slide animation
      const slideDirection = direction === 'left' ? '-100%' : '100%';
      mainImage.style.transition = 'transform 0.3s ease-out';
      mainImage.style.transform = `translateX(${slideDirection})`;

      setTimeout(() => {
        mainImage.style.transition = 'none';
        mainImage.style.transform = 'translateX(0)';
        mainImage.src = productMedia[currentImageIndex];

        // Update dots
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === currentImageIndex);
        });
      }, 300);
    } else {
      // Reset position if swipe was too short
      mainImage.style.transition = 'transform 0.2s ease-out';
      mainImage.style.transform = 'translateX(0)';
    }
  }

  mainImage.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    isDragging = true;
    mainImage.style.transition = 'none';
  }, { passive: true });

  mainImage.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const currentX = e.changedTouches[0].screenX;
    const diff = currentX - touchStartX;
    // Follow finger movement with slight resistance
    mainImage.style.transform = `translateX(${diff * 0.5}px)`;
  }, { passive: true });

  mainImage.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    isDragging = false;
    handleSwipe();
  }, { passive: true });

  // Click on dots to change image
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentImageIndex = index;
    });
  });
}

// Auto Slideshow for Main Gallery
let slideshowInterval = null;
let slideshowResumeTimeout = null;

function initializeAutoSlideshow() {
  const mainImage = document.getElementById('petMainImage');
  const dots = document.querySelectorAll('.pet-dot');

  if (!mainImage || dots.length <= 1) return; // Don't start slideshow if only one image

  let currentImageIndex = 0;

  // Get all product images
  const productMedia = [];
  dots.forEach((dot, index) => {
    const imageUrl = dot.getAttribute('onclick').match(/'([^']+)'/)[1];
    productMedia.push(imageUrl);
  });

  function advanceSlide() {
    currentImageIndex = (currentImageIndex + 1) % productMedia.length;

    // Add fade effect
    mainImage.style.opacity = '0';

    setTimeout(() => {
      mainImage.src = productMedia[currentImageIndex];
      mainImage.style.opacity = '1';

      // Update dots
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentImageIndex);
      });
    }, 300);
  }

  function startSlideshow() {
    // Always clear existing interval before creating new one
    if (slideshowInterval) {
      clearInterval(slideshowInterval);
      slideshowInterval = null;
    }
    slideshowInterval = setInterval(advanceSlide, 7000);
  }

  function stopSlideshow() {
    if (slideshowInterval) {
      clearInterval(slideshowInterval);
      slideshowInterval = null;
    }
    // Also clear any pending resume timeout
    if (slideshowResumeTimeout) {
      clearTimeout(slideshowResumeTimeout);
      slideshowResumeTimeout = null;
    }
  }

  function resumeSlideshowDelayed(delay = 5000) {
    // Clear any existing resume timeout
    if (slideshowResumeTimeout) {
      clearTimeout(slideshowResumeTimeout);
    }
    slideshowResumeTimeout = setTimeout(() => {
      startSlideshow();
    }, delay);
  }

  // Start slideshow initially
  startSlideshow();

  // Pause slideshow on hover (desktop)
  mainImage.addEventListener('mouseenter', () => {
    stopSlideshow();
  });

  mainImage.addEventListener('mouseleave', () => {
    startSlideshow();
  });

  // Pause slideshow on touch (mobile)
  mainImage.addEventListener('touchstart', () => {
    stopSlideshow();
  }, { passive: true });

  mainImage.addEventListener('touchend', () => {
    resumeSlideshowDelayed(5000); // Resume after 5 seconds of inactivity
  }, { passive: true });

  // Add CSS transition to main image
  mainImage.style.transition = 'opacity 0.3s ease-in-out';
}

// Make functions available globally
window.openPetModal = openPetModal;
window.closePetModal = closePetModal;
window.changePetImage = changePetImage;
window.selectPetSize = selectPetSize;
window.selectPetBg = selectPetBg;
window.selectPetFont = selectPetFont;
window.openCustomColorPicker = openCustomColorPicker;
window.closeCustomColorPicker = closeCustomColorPicker;
window.applyCustomColor = applyCustomColor;
window.changeCarouselSlide = changeCarouselSlide;
window.goToSlide = goToSlide;
window.toggleDigitalFile = toggleDigitalFile;
window.toggleFrame = toggleFrame;
window.updateFrameSelection = updateFrameSelection;
window.togglePhotoGuide = togglePhotoGuide;
window.showEmailPopup = showEmailPopup;
window.closeEmailPopup = closeEmailPopup;
window.submitEmailCapture = submitEmailCapture;
